var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"space-container"},_vm._l((_vm.spaces),function(item,index){return _c('span',{key:index,staticClass:"space"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }